export default __webpack_public_path__ + "static/media/green-dot-single.b9f0a8f3.svg";